/*
 *  layout-footer.tsx
 * This Component is used to manage menu functionality in a single header and we'll use it all over the project.
 */

import React from "react";
import styles from "./layout-footer.module.css";
import Text from "../../context/language-context";
import { getNumberInLanguage } from "../../utils/helperFunctions";
export default function LayoutFooter() {
  const TermsAndConditions = async () => {
    try {
      let response = await fetch(
        `/assets/html-template/termsandconditions.html`
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch the HTML. Status: ${response.status}`);
      }
      let html = await response.text();
      const newTab = window.open();

      if (newTab) {
        newTab.document.write(html);
      } else {
        throw new Error("Failed to open a new tab");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const PrivacyPolicy = async () => {
    try {
      let response = await fetch(`/assets/html-template/privacypolicy.html`);

      if (!response.ok) {
        throw new Error(`Failed to fetch the HTML. Status: ${response.status}`);
      }
      let html = await response.text();
      const newTab = window.open();

      if (newTab) {
        newTab.document.write(html);
      } else {
        throw new Error("Failed to open a new tab");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getCurrentYear = () => {
    return new Date().getFullYear();
  };
  return (
    <div className={styles.footer}>
      <div className={styles.footerCondition}>
        <div>
          <span onClick={() => TermsAndConditions()}>
            {Text({
              tid: "COPYRIGHT",
              def: "Copyright",
            })}
            {getNumberInLanguage(getCurrentYear())}{" "}
            {Text({
              tid: "WEBANIX",
              def: "Webanix",
            })}
          </span>
          <span style={{ color: "var(--bs-primary)" }}> | </span>
          <span onClick={() => PrivacyPolicy()}>
            {Text({
              tid: "ALL_RIGHTS_RESERVED",
              def: "All Rights Reserved",
            })}
          </span>
        </div>
      </div>
    </div>
  );
}
